import _ from "lodash"
import moment from "moment"
import React, { useState, useRef, useEffect } from "react"
import { Label, FormFeedback, Input } from "reactstrap"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "react-datepicker/dist/react-datepicker-cssmodules.css"

//Global Functions
import {
  fnDateTimeFromISO,
  fnGetDateTime,
  fnGetDateDiff,
  dateformat,
} from "../../common/global/functions.js"

export const Birthdate = ({ name, id, label, onBlur, validation, ...rest }) => {
  const dateFormat = "yyyy-MM-DD"
  const birthdateHiddenInput = useRef(null)
  const birthdate = moment(
    validation.values.birthdate,
    dateFormat,
    true
  ).isValid()
    ? new Date(moment(validation.values.birthdate))
    : ""
  const minAge = 18
  const maxDate = new Date(moment().subtract(minAge, "years").endOf("day"))
  const maxAge = 100
  const minDate = new Date(moment().subtract(maxAge, "years").startOf("day"))
  const [startDate, setStartDate] = useState(birthdate)
  const years = Array.from({ length: maxAge - minAge + 1 }, (x, i) =>
    Math.abs(i - maxDate.getFullYear())
  )
  const [selectedDate, setSelectedDate] = useState(null)
  const months = moment.months()

  const onDatepickerChange = date => {
    var formattedBirthDate = moment(date, dateFormat, true).isValid()
      ? moment(date).format(dateFormat)
      : ""
    validation.setFieldValue(name, formattedBirthDate)
    birthdateHiddenInput.current.value = formattedBirthDate
  }

  const parseDate = dateString => {
    const formats = ["MM/dd/yyyy", "MM-dd-yyyy", "MM.dd.yyyy", "MMddyyyy"] // Add additional formats as needed
    let parsed = null,
      parsedDate = null,
      valid = formats.some(format => {
        if (dateString.length === 8) {
          const month = dateString.substring(0, 2)
          const day = dateString.substring(2, 4)
          const year = dateString.substring(4, 8)
          parsed = moment(`${year}-${month}-${day}`).isValid()
            ? new Date(`${month}/${day}/${year}`)
            : null
        }

        if (
          parsed &&
          !isNaN(parsed.getTime()) &&
          moment(maxDate).isSameOrAfter(moment(parsed)) &&
          moment(minDate).isSameOrBefore(moment(parsed))
        ) {
          parsedDate = parsed
          return true // Exit loop if a valid date is found
        }
        return false
      })

    return parsedDate
  }

  const onDatepickerBlur = date => {
    onDatepickerChange(parseDate(date.replace(/\D/g, "")))
    validation.setFieldTouched(id, true)
  }

  useEffect(() => {
    onDatepickerChange(startDate)
  }, [startDate])

  useEffect(() => {
    setStartDate(birthdate)
  }, [validation.values.birthdate])

  return (
    <>
      <Input
        type="hidden"
        id={id}
        name={name}
        value={startDate ? startDate : ""}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        ref={birthdateHiddenInput}
      />
      <Label for={"datepicker"}>{label}</Label>
      <DatePicker
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            className="mb-3"
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                    {"<"}
                </button> */}

            <select
              className="form-select"
              value={moment(date).format("MMMM")}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <select
              className="form-select"
              value={moment(date).format("YYYY")}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            {/* <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                    {">"}
                </button> */}
          </div>
        )}
        id={"datepicker"}
        dateFormat="MM/dd/yyyy"
        selected={startDate ? startDate : ""}
        onChange={date => setStartDate(date)}
        onBlur={date => onDatepickerBlur(date.target.value)}
        // onChange={date => {
        //   setStartDate(date)
        //   onDatepickerChange(date)
        // }}
        showWeekNumbers
        minDate={minDate}
        maxDate={maxDate}
        className="form-control"
        placeholderText="MM/DD/YYYY"
        invalid={
          validation.touched.birthdate && validation.errors.birthdate
            ? true
            : false
        }
      />
      {validation.touched.birthdate && validation.errors.birthdate ? (
        <FormFeedback
          type="invalid"
          style={{ display: "block", fontSize: "100%" }}
        >
          {validation.errors.birthdate}
        </FormFeedback>
      ) : null}
    </>
  )
}

export const InitialMonthPayment = ({
  name,
  id,
  label,
  onHandleInitialMonthPaymentDatePickerChange,
  currentMonthPayment,
  validation,
  closeEndAllowedDates: {
    last_non_deferred_date,
    max_date,
    min_date,
    sac_max_date,
  },
  isEte,
  isSameAsCash,
  ...rest
}) => {
  const dateFormat = "yyyy-MM-DD"
  const initialMonthPaymentHiddenInput = useRef(null)

  if (currentMonthPayment.includes("000Z")) {
    currentMonthPayment = fnDateTimeFromISO(currentMonthPayment).toISODate()
  }

  min_date = isEte ? currentMonthPayment : min_date
  max_date = isEte
    ? currentMonthPayment
    : isSameAsCash
    ? sac_max_date
    : max_date
  let { days: daysMaxDiff } = fnGetDateDiff(currentMonthPayment, max_date, [
    "days",
  ])
  let { days: daysMinDiff } = fnGetDateDiff(currentMonthPayment, min_date, [
    "days",
  ])

  currentMonthPayment = daysMinDiff < 0 ? min_date : currentMonthPayment
  currentMonthPayment = daysMaxDiff > 0 ? max_date : currentMonthPayment
  const initialMonthPayment = moment(
    currentMonthPayment,
    dateFormat,
    true
  ).isValid()
    ? new Date(moment(currentMonthPayment))
    : ""

  const maxDate = new Date(moment(max_date))
  const minDate = new Date(moment(min_date))

  const [startDate, setStartDate] = useState(initialMonthPayment)
  const years = isEte
    ? [minDate.getFullYear()]
    : _.range(minDate.getFullYear(), maxDate.getFullYear() + 1)

  let lastRangeMonth =
    maxDate.getFullYear() > minDate.getFullYear()
      ? maxDate.getMonth() + 12
      : maxDate.getMonth()
  let rangemonths = _.range(minDate.getMonth(), lastRangeMonth + 1)

  //get months that are valid for the payment dates. Invalid not changeable
  rangemonths = _.map(rangemonths, rangemonth => {
    return rangemonth >= 12 ? rangemonth - 12 : rangemonth
  })
  const months = isEte
    ? _.toArray(_.pick(moment.months(), [initialMonthPayment.getMonth()]))
    : moment.months()

  const onDatepickerChange = date => {
    var formattedInitialMonthPayment = moment(date, dateFormat, true).isValid()
      ? moment(date).format(dateFormat)
      : ""
    //validation.setFieldValue(name,formattedInitialMonthPayment);
    initialMonthPaymentHiddenInput.current.value = formattedInitialMonthPayment

    onHandleInitialMonthPaymentDatePickerChange(initialMonthPaymentHiddenInput)
  }

  useEffect(() => {
    var { days: daysMaxDiff } = fnGetDateDiff(
      moment(startDate).format(dateFormat),
      max_date,
      ["days"]
    )
    var { days: daysMinDiff } = fnGetDateDiff(
      moment(startDate).format(dateFormat),
      min_date,
      ["days"]
    )

    //if datepicker date is greater than max date (SAC changed), change to initial_month_payment = currentMonthPayment = max_date
    if (daysMaxDiff > 0 || daysMinDiff < 0) {
      setStartDate(new Date(moment(currentMonthPayment)))
      initialMonthPaymentHiddenInput.current.value = currentMonthPayment
      onHandleInitialMonthPaymentDatePickerChange(
        initialMonthPaymentHiddenInput
      )
    } else {
      // *** should not happen ***component reload cause of sac changes keep the current startDate if it is valid
      var { days: daysDiff } = fnGetDateDiff(
        moment(startDate).format(dateFormat),
        currentMonthPayment,
        ["days"]
      )

      if (daysDiff != 0) {
        validation.setFieldValue(name, moment(startDate).format(dateFormat))
        initialMonthPaymentHiddenInput.current.value =
          moment(startDate).format(dateFormat)
        onHandleInitialMonthPaymentDatePickerChange(
          initialMonthPaymentHiddenInput
        )
      }
    }
  }, [currentMonthPayment])

  return (
    <>
      <Input
        type="hidden"
        id={id}
        name={name}
        value={startDate ? startDate : ""}
        //onChange={}
        ref={initialMonthPaymentHiddenInput}
        disabled={"disabled"}
      />
      <Label for={"datepicker"}>{label}</Label>
      <DatePicker
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            className="mb-3"
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                      {"<"}
                  </button> */}

            <select
              className="form-select"
              value={moment(date).format("MMMM")}
              onChange={({ target: { value } }) => {
                _.findIndex(rangemonths, function (o) {
                  return o == months.indexOf(value)
                }) != -1
                  ? changeMonth(months.indexOf(value))
                  : false
              }}
            >
              {months.map((option, key) => (
                <option
                  key={option}
                  value={option}
                  disabled={_.indexOf(rangemonths, key) == -1 ? "disabled" : ""}
                  className={
                    _.indexOf(rangemonths, key) == -1
                      ? "text-muted"
                      : "text-dark"
                  }
                >
                  {option}
                </option>
              ))}
            </select>

            <select
              className="form-select"
              value={moment(date).format("YYYY")}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            {/* <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                      {">"}
                  </button> */}
          </div>
        )}
        id={"datepicker"}
        dateFormat="MM/dd/yyyy"
        selected={startDate ? startDate : ""}
        onChange={date => {
          setStartDate(date)
          onDatepickerChange(date)
        }}
        //isClearable
        //placeholderText="I have been cleared!"
        //locale="en-US"
        showWeekNumbers
        minDate={minDate}
        maxDate={maxDate}
        className="form-control"
        placeholderText="MM/DD/YYYY"
        invalid={
          validation.touched.initial_month_payment &&
          validation.errors.initial_month_payment
            ? true
            : false
        }
      />
      {validation.touched.initial_month_payment &&
      validation.errors.initial_month_payment ? (
        <FormFeedback
          type="invalid"
          style={{ display: "block", fontSize: "100%" }}
        >
          {validation.errors.initial_month_payment}
        </FormFeedback>
      ) : null}
    </>
  )
}
